import { useRef } from 'react';
import { useIsomorphicLayoutEffect } from './use-isomorphic-effect.mjs';

function useIsMounted() {
    var isMounted = useRef(false);
    useIsomorphicLayoutEffect(function () {
        isMounted.current = true;
        return function () {
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}

export { useIsMounted };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/utils/use-is-mounted.mjs
// module id = CnXR
// module chunks = 0